export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center bg-background-100 rounded-2xl p-8 md:p-12">
          <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center bg-primary-100 text-primary-600 rounded-2xl text-3xl">
            <i className="ri-mail-send-line"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto">
            如果你有漫画推荐、投稿、合作等需求，欢迎随时联系我们。我们珍视每一位漫迷的声音，期待与你一起打造更好的漫画阅读社区。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 flex-wrap">
            <span className="inline-flex items-center gap-2 text-sm text-foreground-700 bg-background-50 px-4 py-2 rounded-lg">
              <i className="ri-mail-line text-primary-500"></i>
              contact@aimanhua.com
            </span>
            <span className="inline-flex items-center gap-2 text-sm text-foreground-700 bg-background-50 px-4 py-2 rounded-lg">
              <i className="ri-wechat-line text-primary-500"></i>
              微信公众号：爱漫画网
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}